import { FormControl } from '@material-ui/core';
import styled, { css } from 'styled-components';

export const Wrapper = styled(FormControl)`
  width: 100%;

  .__group {
    display: flex;
  }

  .MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }
`;

export const GroupInput = styled.div`
  display: flex;
  align-items: center;

  .input {
    .MuiOutlinedInput-notchedOutline {
      border-right: 0;
    }

    .MuiOutlinedInput-root {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline,
    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-width: 1px;
      border-color: rgba(0, 0, 0, 0.23);
    }

    .MuiFormLabel-root.Mui-focused {
      color: rgba(0, 0, 0, 0.54);
    }
  }

  .input_disabled {
    .MuiOutlinedInput-root {
      border-radius: 0;
    }
  }

  .MuiIconButton-sizeSmall {
    padding: 0.84rem;

    @media (max-width: 425px) {
      padding: 7px;
    }
  }

  .MuiIconButton-root {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;

    background-color: rgba(0, 0, 0, 0.23);
    color: #fff;

    & :hover {
      background-color: transparent;
    }
  }

  ${({ error }) =>
    error &&
    css`
      .MuiFormLabel-root {
        color: #f44336;
      }

      .MuiOutlinedInput-notchedOutline,
      .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
        border-color: #f44336;
      }

      .MuiIconButton-root {
        background-color: #f44336;
      }

      .input {
        .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline,
        .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
          border-color: #f44336;
        }
      }
    `}
`;
